export default "__VITE_ASSET__BKSBj$lW__"